import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import ApplicantsAppointmentForm from "./ApplicantsAppointmentForm";

export interface State {}

export interface CreateApplicantAppointmentFormProps
  extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  codebooks: any[];
}

class CreateApplicantAppointmentForm extends React.Component<
  CreateApplicantAppointmentFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let newApplicantAppointmentData = null;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newApplicantAppointmentData = values;
        }
      });
      return newApplicantAppointmentData;
    });
  }

  render() {
    const { translate, codebooks } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <ApplicantsAppointmentForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        codebooks={codebooks}
      />
    );
  }
}

export default CreateApplicantAppointmentForm;
